import React from 'react';

// Sidebar filter for the stored Inbox/Sent list: chips by the AI fields.
// Category management lives on the full mail page (EmailLabels), not here.
const SENDERS = [
  ['stakeholder', 'Stakeholder'],
  ['vendor', 'Vendor'],
  ['client', 'Client'],
  ['team', 'Team'],
  ['other', 'Other'],
];

const Chip = ({ label, count, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={active}
    title={label}
    className={`flex min-w-0 max-w-full items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium transition-colors ${
      active
        ? 'border-transparent bg-[#5652CF] text-white'
        : 'border-zinc-700 text-zinc-300 hover:bg-zinc-800'
    }`}
  >
    <span className="truncate">{label}</span>
    <span className={`shrink-0 ${active ? 'text-white/70' : 'text-zinc-500'}`}>
      {count}
    </span>
  </button>
);

const Section = ({ title, children }) => (
  <div className="space-y-1.5">
    <p className="text-[10px] font-semibold uppercase tracking-widest text-zinc-500">
      {title}
    </p>
    <div className="flex flex-wrap gap-1.5">{children}</div>
  </div>
);

export default function MailFilters({
  emailStats = {},
  emailfilter,
  onToggle,
  onClear,
}) {
  const senderCounts = emailStats.sender_class_counts || {};
  const categoryCounts = emailStats.objective_class_counts || {};
  // Only categories that have mail, busiest first.
  const categories = (emailStats.objective_classes || [])
    .map((c) => [c.name, categoryCounts[c.name] || 0])
    .filter(([, count]) => count > 0)
    .sort((a, b) => b[1] - a[1]);
  const active = ['isRead', 'urgency', 'senderClass', 'objectiveClass'].some(
    (key) => emailfilter[key] !== undefined,
  );

  return (
    <div className="w-60 space-y-3 rounded-xl border border-zinc-700 bg-zinc-900 p-3 shadow-2xl">
      <div className="flex items-center justify-between">
        <p className="text-[13px] font-medium text-zinc-200">Filter</p>
        {active && (
          <button
            type="button"
            onClick={onClear}
            className="text-[11px] text-[#9b98f5] hover:underline"
          >
            Clear
          </button>
        )}
      </div>
      <Section title="Show">
        <Chip
          label="Unread"
          count={emailStats.unread_count || 0}
          active={emailfilter.isRead === false}
          onClick={() => onToggle('isRead', false)}
        />
        <Chip
          label="Urgent"
          count={emailStats.urgent_count || 0}
          active={emailfilter.urgency === true}
          onClick={() => onToggle('urgency', true)}
        />
      </Section>
      <Section title="From">
        {SENDERS.map(([value, label]) => (
          <Chip
            key={value}
            label={label}
            count={senderCounts[value] || 0}
            active={emailfilter.senderClass === value}
            onClick={() => onToggle('senderClass', value)}
          />
        ))}
      </Section>
      {categories.length > 0 && (
        <Section title="Category">
          {categories.map(([name, count]) => (
            <Chip
              key={name}
              label={name}
              count={count}
              active={emailfilter.objectiveClass === name}
              onClick={() => onToggle('objectiveClass', name)}
            />
          ))}
        </Section>
      )}
    </div>
  );
}
